import React from "react";
import * as styles from "./style.mod.scss";
import { Container } from "react-bootstrap";
import getImagePath from "helpers/get-image-path";
import Link from "components/link";
import Countdown from "./countdown";

const CountdownBanner = ({ data, handle, excludeBanner }) => {
  if (!data) return<></>;
  const { banner, bannerType, showBanner, enableBannerTimer, url, homepage, pdp, collection, timer } = data;
  let image = banner;

  if (bannerType === "different") {
    switch (true) {
    case handle === "/":
      image = homepage;
      break;
    case handle?.includes("collections"):
      image = collection;
      break;
    default:
      image = pdp;
      break;
    }

  }

  if (!showBanner || !image || excludeBanner) return <></>;

  return (
    <Link to={url}>
      <div className={styles.permanentBannerWithCountdown}>
        <img className={styles.bannerImageDesktop} src={getImagePath(image?.desktop)} alt={image?.desktop?.alt} />
        <img className={styles.bannerImageMobile} src={getImagePath(image?.mobile)} alt={image?.mobile?.alt} />
        {enableBannerTimer &&
          <Container className={styles.smallBanner}>
            <Countdown timer={timer} title={data?.title} message={data?.message} />
          </Container>}
      </div>
    </Link>
  );
};

export default CountdownBanner;